import { render, staticRenderFns } from "./PropSelectItem.vue?vue&type=template&id=11d0352b&scoped=true"
import script from "./PropSelectItem.vue?vue&type=script&lang=ts"
export * from "./PropSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./PropSelectItem.vue?vue&type=style&index=0&id=11d0352b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0352b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d0352b')) {
      api.createRecord('11d0352b', component.options)
    } else {
      api.reload('11d0352b', component.options)
    }
    module.hot.accept("./PropSelectItem.vue?vue&type=template&id=11d0352b&scoped=true", function () {
      api.rerender('11d0352b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/prop-select/PropSelectItem.vue"
export default component.exports